<template>
  <div
    :class="
      browserSize.xs === true || browserSize.sm === true
        ? 'methods'
        : 'methods2'
    "
  >
    <v-row>
      <v-col>
        <img
          width="150"
          height="150"
          class="iconMargin"
          src="../assets/Kinesio-Taping.jpg"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        col-md-12
        class="infText text-center"
        v-if="browserSize.xs === true || browserSize.sm === true"
      >
        <div class="display-1 font-weight-black grey--text text-center">
          {{ title }}
        </div>
      </v-col>
      <v-col col-md-12 class="infText text-center" v-else>
        <div class="display-2 font-weight-black grey--text text-center">
          {{ title }}
        </div>
      </v-col>
    </v-row>

    <p class="paragraph"><b>Wskazania:</b></p>
    <li class="paragraph2" v-for="item in wskazania" :key="item.index">
      {{ item }}
    </li>

    <v-row>
      <v-col class="col-11">
        <span class="aboutText">
          {{ opis1 }}
        </span>
      </v-col>
    </v-row>

    <p class="paragraph">
      <b>{{ opis2 }}</b>
    </p>
    <li class="paragraph2" v-for="item in list" :key="item.index">
      {{ item }}
    </li>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "Kinesiology Taping",
      wskazania: [
        "blizny,",
        "wskazania do drenażu limfatycznego,",
        "dolegliwości bólowe kręgosłupa pochodzenia mięśniowego, więzadłowego,",
        "kontuzje.",
      ],
      opis1:
        "Metoda, w której wykorzystuje się elastyczne plastry. Dzięki zastosowaniu techniki mięśniowej, więzadłowej bądź powięziowej można uzyskać efekt odciążenia, stabilizacji lub zredukowania dolegliwości bólowych zmienionej chorobowo tkanki podskórnej i mięśniowej. Terapia stosowana jest jako przedłużenie leczenia bezpośredniego i utrwalenie osiągniętych efektów uzyskanych w trakcie wizyty fizjoterapeutycznej. Każdorazowo przed zastosowaniem plastra wykonuje się test ruchu lub ślizgu zmienionej bólowo/chorobowo tkanki.",

      opis2:
        "Metoda Kinesiology Taping wpływa na podstawowe funkcje fizjologiczne:",

      list: [
        "redukuje ból lub nadwrażliwość czuciową w skórze i mięśniach,",
        "koryguje działanie mięśni,",
        "redukuje nadmiar płynu limfatycznego powodującego obrzęki,",
        "koryguje pozycje stawu.",
      ],
    };
  },
  computed: {
    browserSize() {
      return this.$vuetify.breakpoint;
    },
  },
};
</script>

<style lang="scss" scoped>
.methods {
  margin-top: 12vh;
}
.methods2 {
  margin-top: 4vh;
}
.v-application .grey--text {
  color: #414149 !important;
}
.infText {
  margin: auto;
}
.paragraph {
  font-weight: bold;
  margin-top: 10px;
  text-align: left;
  margin-left: 6vw;
  margin-right: 3vw;
}
.paragraph2 {
  text-align: left;
  margin-left: 7vw;
  margin-right: 3vw;
}
.textWhy {
  margin-top: 25px;
  text-align: center;
}
.textWhyPhone {
  margin-top: 25px;
  margin-bottom: 25px;
  text-align: justify;
  text-align-last: left;
}
.aboutText {
  text-align-last: left;
  display: flex;
  align-items: center;
  justify-content: center;
  text-indent: 1.5em;
}
.row {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  margin: auto;
  max-height: 50%;
}
.col {
  text-align: justify;
  text-align-last: center;
}
.col-11 {
  flex: 0 0 91.666667%;
  max-width: 91.666667%;
  align-content: center;
  display: flex;
  margin: auto;
}
</style>